import { TableCellPerColumn } from "ds/components/TableSimple/types";

import { ScansListItem } from "../../../types";
import { SCANS_COLUMN_ID } from "../constants";
import ScansTableDropdownCell from "./DropdownCell";
import ScansTableLabelsCell from "./LabelsCell";
import ScansTableLastScanCell from "./LastScanCell";
import ScansTableNameCell from "./NameCell";
import ScansTableProviderCell from "./ProviderCell";
import ScansTableStatusCell from "./StatusCell";
import ScansTableUnmanagedResourcesCell from "./UnmanagedResourcesCell";

const SCANS_TABLE_CELLS: TableCellPerColumn<ScansListItem> = {
  [SCANS_COLUMN_ID.NAME]: ScansTableNameCell,
  [SCANS_COLUMN_ID.STATUS]: ScansTableStatusCell,
  [SCANS_COLUMN_ID.UNMANAGED_RESOURCES]: ScansTableUnmanagedResourcesCell,
  [SCANS_COLUMN_ID.PROVIDER]: ScansTableProviderCell,
  [SCANS_COLUMN_ID.LABELS]: ScansTableLabelsCell,
  [SCANS_COLUMN_ID.LAST_SCAN]: ScansTableLastScanCell,
  [SCANS_COLUMN_ID.DROPDOWN]: ScansTableDropdownCell,
};

export default SCANS_TABLE_CELLS;
